import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import {DateControllerStateDirective} from "../../entities";
import {CALENDAR_TYPES, TIntCalendarOutput} from "../../shared";

@Component({
  selector: 'int-calendar',
  templateUrl: './int-calendar.component.html',
  styleUrls: ['./int-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntCalendarComponent {

  _currentDate: [Date | null, Date | null] = [null, null];

  @Input() set currentDate( date: Date | null | [Date | null, Date | null]) {
    this._currentDate = Array.isArray(date) ? date : [date, null];
  };

  @Input() type: keyof typeof CALENDAR_TYPES = 'single'

  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;
  @Input() markWeekends = true;

  @ViewChild(DateControllerStateDirective) private readonly controller!: DateControllerStateDirective;

  @Output() onChange = new EventEmitter<TIntCalendarOutput>();

  constructor(
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  onSelect(selected: TIntCalendarOutput) {
    this.onChange.emit(selected);
  }
}
